import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonCol, IonRow } from '@ionic/angular/standalone';
import { CodReportsModule } from './cods/cod-reports.module';
import { ErrorReportsModule } from './error/error-report.module';
import { ExceptionsReportsModule } from './exceptions-reports/exceptions-reports.module';
import { OnRoadOperationModule } from './on-road-operation/on-road-operation.module';
import { OtherModule } from './other/other.module';

@NgModule({
  imports: [
    ExceptionsReportsModule,
    OtherModule,
    OnRoadOperationModule,
    CodReportsModule,
    IonCol,
    IonRow,
    ErrorReportsModule,
  ],
  exports: [
    ExceptionsReportsModule,
    OtherModule,
    OnRoadOperationModule,
    CodReportsModule,
    ErrorReportsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportPopupsModule {}
